import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const ClientExperience = props => (
  <SvgIcon height="512" viewBox="0 0 511.963 511.963" width="512" {...props}>
    <g>
      <path d="m30.933 254.943 50.048-15.669 50.05 15.669.564-52.442 30.368-42.758-49.701-16.741-31.281-42.095-31.28 42.095-49.701 16.742 30.369 42.757z" />
      <path d="m204.995 194.942 50.05-15.668 50.05 15.668.563-52.441 30.368-42.758-49.701-16.741-31.28-42.095-31.28 42.095-49.702 16.741 30.369 42.758z" />
      <path d="m380.933 254.943 50.048-15.669 50.05 15.669.564-52.442 30.368-42.758-49.701-16.741-31.281-42.095-31.28 42.095-49.701 16.742 30.369 42.757z" />
      <circle cx="255.045" cy="336.056" r="15" />
      <path d="m225.045 441.056v26.203c9.592 2.478 19.645 3.797 30 3.797s20.408-1.319 30-3.797v-26.203c0-16.542-13.458-30-30-30s-30 13.458-30 30z" />
      <path d="m195.045 454.947v-13.891c0-33.084 26.916-60 60-60-24.813 0-45-20.187-45-45s20.187-45 45-45 45 20.187 45 45-20.187 45-45 45c33.084 0 60 26.916 60 60v13.891c35.84-20.779 60-59.565 60-103.891 0-66.168-53.832-120-120-120s-120 53.832-120 120c0 44.325 24.16 83.112 60 103.891z" />
    </g>
  </SvgIcon>
);

export default ClientExperience;
